import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["code", "message", "meta", "source"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Standard Javascript error object that should be used for
 * propagating, operating and logging of errors in marketplace-frontend
 **/

import { nanoid } from 'nanoid';
/**
 * Wraps a passed function after dynamically
 * setting the function name. The function name
 * is minification-proof.
 */
function withName(name, fn) {
  function wrappedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return fn.apply(this, args);
  }
  Object.defineProperty(wrappedFunction, 'name', {
    value: name
  });
  return wrappedFunction;
}

// If a transform function is specified, the fields passed
// to the error constructor should match fields passed to the
// transform function. Else they should match standard `ErrorFields`

/**
 * Factory function for creating new error types.
 * Takes an optional transform function that is expected
 * to return standard ErrorFields.
 *
 * @example
 * const SimpleError = createErrorType('SimpleError')
 * throw new SimpleError({ code: 'code', message: 'something went wrong'})
 * ----
 * type BuiltErrorFields = { foo: string }
 * const BuiltError =  createErrorType<BuiltErrorFields>('BuiltError', ({ foo }) => ({ code: foo, message: 'bar' }))
 * throw new BuiltError({ foo: 'baz'})
 */
const createErrorType = (type, transform) => {
  // MC-2850 To-do fix the typing for "this"
  const CustomError = withName(type, function (params) {
    const finalParams = transform ? transform(params) : params;
    const {
        code,
        message,
        meta,
        source
      } = finalParams,
      other = _objectWithoutProperties(finalParams, _excluded);
    this.code = code;
    this.message = message;
    this.id = nanoid(9);
    this.type = type;
    this.source = source;
    this.meta = _objectSpread(_objectSpread({}, meta), other);
    this.toJSON = () => _objectSpread({
      id: this.id,
      code: this.code,
      type: this.type,
      message: this.message,
      meta: this.meta
    }, this.source && {
      source: this.source.toJSON ? this.source.toJSON() : this.source.message ? this.source.message : this.source
    });
    this.toString = () => JSON.stringify(this.toJSON());
    if (Object.prototype.hasOwnProperty.call(Error, 'captureStackTrace')) {
      Error.captureStackTrace(this, CustomError);
    } else {
      this.stack = new Error(message).stack;
    }
  });
  if (typeof Object.setPrototypeOf === 'function') {
    Object.setPrototypeOf(CustomError.prototype, Error.prototype);
  } else {
    CustomError.prototype = Object.create(Error.prototype, {
      constructor: {
        value: CustomError
      }
    });
  }
  return CustomError;
};
export default createErrorType;